import {Component, ElementRef, Input, Output, EventEmitter, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Config} from '../config';
import { MapService } from '../map-view/map.service';
import { EventsService } from '../EventsService';
import { EsriTasksService } from '../esriTasks/esriTasks-service';
import {Observable} from 'rxjs/Observable';
import {LocationService} from './addressLocator.service';
import Geometry = require('esri/geometry/Geometry');
import Graphic = require('esri/Graphic');
import SimpleFillSymbol = require('esri/symbols/SimpleFillSymbol');
import SimpleLineSymbol = require('esri/symbols/SimpleLineSymbol');
import PictureMarkerSymbol = require('esri/symbols/PictureMarkerSymbol');
import Color = require('esri/Color');
import {Jsonp, Http, Headers, URLSearchParams, Response} from '@angular/http';

@Component({
    selector: 'addressLocator-component',
    template: require('../tools/addressLocator.component.html'),
    styles: [require('../tools/addressLocator.component.css')]
})
export class AddressLocatorComponent {
    appSettings: Object = null;
    searchInProgress:boolean = false;

    @ViewChild('searchinput') searchinput: ElementRef;
    @Input() inputWidth: string = "";
    @Input() inputPlaceHolderText:string = "Enter an address, parcel #, an intersection, or neighborhood name here...";
    @Output() addressLocationOutput = new EventEmitter<object>();
    @Output() addressSuggestionsOutput = new EventEmitter<object>();

    public typedAddress:string;
    public suggestions:Array<Object>;
    values='';
    error: any;
    pickedAddress: any;
    term = new FormControl();
    ignoreTextChange: boolean = false;
    placeHolderText:String = "Type an address or intersection";
    enableFallback: boolean = false;
    items: Observable<Array<Object>>;
    fallbackRun:boolean = false;
    dialogShow:boolean = false;

    validRangesHeader:string = "";
    oneSuggStreet:boolean = false;
    validStreetRanges:Array<Object>;

    neighborhoodsList:Array<Object> = [];
    parsedAddress:Object = new Object;
    jsonpCallback:string = "";
    searchType:string = "";
    locateServiceURL:string = "";
    concatenators:Array<string> = [];


    constructor(private elRef: ElementRef, private locationService: LocationService, private _eventsService: EventsService, private _esriTasksService:EsriTasksService, private _mapService:MapService, private http: Http, private jsonp:Jsonp) {
        if(this.appSettings == null){
            this.appSettings = Config.config[0];
        }
    }

    ngOnInit() {
        // create the map
        //this._mapService.createMap(this.itemId, this.elRef.nativeElement.firstChild, this.options).then((response) => {
        //  // get a reference to teh map and expose response to app
        //  this.map = response.map;
        //  this.mapLoaded.next(response);
        //});
        
        this.term.valueChanges
                            .debounceTime(400)
                            //.distinctUntilChanged()
                            .switchMap(term => this.turnOnInProgress(term))
                            //.catch(this.handleObservableError)
                            //.finally(() => console.log("finally"))
                            .subscribe(suggestions => this.suggestionsReceived(suggestions))//, err => this.handleError(err));
                                    
        // this.locationService.navItem$.subscribe(item => 
        //     item ? this.searchInProgress = true : this.searchInProgress = false
        // );

        this._esriTasksService.queryFeatures(this.appSettings["AddressLocator"]["neighborhoodsMapService"], null, "1=1", ["NAME"], false, null).then(results => {
            results.features.forEach(element => {
                this.neighborhoodsList.push(element.attributes["NAME"]);
            });
        })

        this.locateServiceURL = this.appSettings["AddressLocator"]["serviceUrl"];
        this.concatenators = this.appSettings["AddressLocator"]["concatenators"];
        this.jsonpCallback = this.appSettings["AddressLocator"]["jsonpCallback"];
    }

    private turnOnInProgress(term:string){
        //check if this is a parcel number
        if((term as string).length == 7 && !isNaN(parseInt(term)))
        {
            this.queryForParcelNumber(term as string);
            return[];
        }
        //check if this is a neighborhood name
        if(this.neighborhoodsList.some(function(element:string, index, array){
            return element.toUpperCase() == term.toUpperCase();
        })){
            this.suggestions = [];
            var neighbName:any = this.neighborhoodsList.find(x => (x as string).toUpperCase() == term.toUpperCase());
            this.suggestions.push({"FullAddress":term.toUpperCase(), "FullName":neighbName, "SuggestionType":"Neighborhood"});
            return [];
        }
        //Clear suggestions if this is either parcel or neighborhood
        if(this.suggestions){
            if(this.suggestions.length > 0 && (this.suggestions[0]["SuggestionType"] == "ParcelNumber" || this.suggestions[0]["SuggestionType"] == "Neighborhood")){
            this.suggestions = [];
            }
        }
        //(Might not be needed) clear suggestions
        if (this.ignoreTextChange == false){
            this.searchInProgress = true;
            //return this.locationService.getAddressSuggestions(term);
            return this.getAddressSuggestions(term);
        }else{
            return [];   
        }
    }

    getAddressSuggestions(typedAddress):any{
        if(!typedAddress){
            this.searchInProgress = false;
            return new Array<Object>();
        }
        var urlAddress:string = this.constructURL(typedAddress);
        
        // return this.jsonp.get(urlAddress + "?method=JSONP_CALLBACK")
        //     .toPromise()
        //     .then(
        //         (response) => response.json()
        //     ).catch(this.handleError);
        if(urlAddress != ""){
            this.searchInProgress = true;
            
            return this.jsonp.get(urlAddress + this.jsonpCallback)
               .map(response => {
                    var suggestionsArray = response.json();
                    for (var sug of suggestionsArray){
                        sug["SuggestionType"] = this.searchType;
                    }
                    return suggestionsArray;
               }).catch(this.handleObservableError);
        }
        this.searchInProgress = false;
        return new Array<Object>();
    }

    private handleObservableError(error:Response){
        return Observable.of([]);
    }

    private handleError(error: any) {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }

    constructURL(typedAddress:string):string{
        var url:string = "";
        this.parsedAddress = new Object();
        var parsedAddressArray:Array<string> = [typedAddress.substring(0, typedAddress.indexOf(" ")), typedAddress.substring(typedAddress.indexOf(" "))];
        if(Number(parsedAddressArray[0])){
            this.parsedAddress["streetNumber"] = parsedAddressArray[0];
            if(parsedAddressArray[1] != " "){
                parsedAddressArray[1] = parsedAddressArray[1].replace(/[ ]+/g, " ").trim();
            }
            this.parsedAddress["streetName"] = parsedAddressArray[1];
            if(this.searchType == "Streets"){
                this.parsedAddress["type"] = "Streets";
                url = this.locateServiceURL + "StreetAddresses/" + this.parsedAddress["streetNumber"] + "/" + parsedAddressArray[1];
                return url;
            }
            this.parsedAddress["type"] = "Address";
            url = this.locateServiceURL + "Addresses/" + this.parsedAddress["streetNumber"] + "/" + parsedAddressArray[1] + "/true/true/true";
            this.searchType = "Address";
            return url;
        }
        for (var conc of this.concatenators){
            if(typedAddress.toLowerCase().indexOf(" " + conc.toLowerCase() + " ") != -1 && typedAddress.toLowerCase().split(" " + conc.toLowerCase() + " ").length > 1 && typedAddress.toLowerCase().split(" " + conc.toLowerCase() + " ").indexOf("") == -1){
                var intersections:Array<string> = typedAddress.toLowerCase().split(" " + conc.toLowerCase() + " ");
                url = this.locateServiceURL + "Intersections/" + intersections[0] + "/" + intersections[1] + "/" + conc.toLowerCase();
                this.searchType = "Intersection";
                return url;
            }
        }
        return url;
    }
    
    emptySuggestionsFallback(){
        if (this.enableFallback == true){
            //this.locationService.searchType = "Streets";
            this.searchType = "Streets";
            this.fallbackRun = true;
            this.term.setValue(this.searchinput.nativeElement.value);
        }else{
            return;
        }
    }

    // destroy map
    ngOnDestroy() {

    }       
    
    onKey(event:any) {
        this.ignoreTextChange = false;
        if(this.searchinput.nativeElement.value == ""){
            this.suggestions = [];
            this.searchInProgress = false;
        }
        if(event.keyCode == 13){
            this.enableFallback = true;
            this.term.setValue(this.searchinput.nativeElement.value);
        }else if(event.keyCode == 27){
            this.suggestions = [];
            this.searchInProgress = false;
            this.fallbackRun = false;
            this.searchinput.nativeElement.value = "";
        }else{
            this.fallbackRun = false;
        }
        // setTimeout(() => {
        //     if(this.typedAddress.length > 3 && this.locationService.constructURL(this.typedAddress) != ""){
                // this.searchInProgress = true;
                // this.locationService
                //     .getAddressSuggestions(this.typedAddress)
                //     .subscribe(suggestions => 
                //         this.suggestionsReceived(suggestions))
                    //.catch(error => this.error = error); // TODO: Display error message
        //     }else{
        //         this.suggestions = [];
        //     }
        // }, 700);
    }

    onKeyDown(event:any){
        this.fallbackRun = false;
    }
    
    
    suggestionsReceived(suggestions){
        this.searchInProgress = false;
        this.suggestions = [];
        if (suggestions.length == 0){
            if(this.enableFallback == true){
                this.emptySuggestionsFallback();
            }else if(this.fallbackRun == true){
                this.findStreetRanges();
                //this.locationService.searchType = "";
                this.searchType = "";
                this.fallbackRun = false;
            }
            this.enableFallback = false;
            return;
        }else{
            this.enableFallback = false;
        }
        suggestions.sort((n1,n2) => {
            if (n1["Level"] > n2["Level"]) {
                return -1;
            }
            if (n1["Level"] < n2["Level"]) {
                return 1;
            }
            return 0;
        });
        for (var suggestion of suggestions) {
            if (this.weedoutDuplicateSuggestions(suggestion) == false){
                suggestion = this.constructFullAddress(suggestion);
                this.suggestions.push(suggestion);
            }
        }
        this.suggestions.sort((n1,n2) => {
            if (n1["FullAddress"] > n2["FullAddress"]) {
                return 1;
            }
            if (n1["FullAddress"] < n2["FullAddress"]) {
                return -1;
            }
            return 0;
        });
        this.locationService.searchType = "";
        //emit event that suggestions were received
        this.addressSuggestionsOutput.next(suggestions);
    }


    private queryForParcelNumber(parcelNumber:string){
        this.searchInProgress = true;
        this._esriTasksService.queryFeatures(this.appSettings["AddressLocator"]["parcelsMapService"], null, ("PARCEL_C = '" + parcelNumber + "'"), ["PARCEL_C", "STNUMBER", "PRE_DIR", "FULL_STNAME", "CITY", "STATE", "ZIPCODE"], true, null).then(results => {
            this.suggestions = [];
            var parcelAttrs:object = results.features[0].attributes;
            var fullAddress:string = parcelAttrs["STNUMBER"] + " " + parcelAttrs["PRE_DIR"] + " " + parcelAttrs["FULL_STNAME"] + " " + parcelAttrs["CITY"] + ", " + parcelAttrs["STATE"] + " " + parcelAttrs["ZIPCODE"];
            this.suggestions.push({"FullAddress":parcelNumber, "SuggestionType":"ParcelNumber", "FullName":parcelNumber, "ShowAddress": fullAddress, "Geometry":results.features[0].geometry});
            this.searchInProgress = false;
        });
    }

    private constructFullAddress(suggestion:Object){
        if(suggestion["SuggestionType"] == "Streets"){
            //var num = this.locationService.parsedAddress["streetNumber"];
            var num = this.parsedAddress["streetNumber"];
            var zip;
            var city;
            if(suggestion["FromLeft"] % 2 ==num % 2 && suggestion["FromLeft"] <= num && suggestion["FromLeft"] >= num){
                city = suggestion["LeftCity"];
                zip = suggestion["LeftZip"];
            }else{
                city = suggestion["RightCity"];
                zip = suggestion["RightZip"];
            }
            suggestion["FullAddress"] = num + " " + suggestion["FullName"] + ", " + city;
            suggestion["StreetNumber"] = num;
            suggestion["FullName"] = num + " " + suggestion["FullName"];
            suggestion["Zip"] = zip;
            suggestion["City"] = city;
        }else if(suggestion["SuggestionType"] == "Address"){
            if(suggestion["Unit"]){
                suggestion["FullAddress"] = suggestion["FullName"] + (suggestion["Unit"] == "" ? "" : " #" + suggestion["Unit"]) + ", " + suggestion["City"];
            }else{
                suggestion["FullAddress"] = suggestion["FullName"] + ", " + suggestion["City"];
            }
            suggestion["StreetNumber"] = suggestion["HouseNum"];
        }else{
            suggestion["FullAddress"] = suggestion["FullName"] + ", " + suggestion["City"];
        }
        return suggestion;
    }
    
    
    private weedoutDuplicateSuggestions(suggestion:Object):boolean{
        for (var sug of this.suggestions){
            if (sug["FullName"] + " #" + sug["Unit"] == suggestion["FullName"] + " #" + suggestion["Unit"]) {
                return true;
            }
        }
        return false;
    }
    
    findStreetRanges(){
        this.locationService
            .getStreetRanges()
            .then(addressRanges => 
                this.processStreetRanges(addressRanges))
            .catch(error => this.error = error); // TODO: Display error message
    }

    processStreetRanges(addressRanges){
        //Create some variables
        var ranges=new Array();
        var rangesObjArray = new Array();
        //Flag if this is only one street
        var _suggStreets = new Array();
        for(var street of addressRanges){
            //Get street & address ranges
            var stname = street.FullName;
            var lf = street.FromLeft;
            var lt = street.ToLeft;
            var rf = street.FromRight;
            var rt = street.ToRight;
            var min = Math.min(lf, lt, rf, rt);
            var max = Math.max(lf, lt, rf, rt);
        
            //See if this street already is in my list
            var range = null;
            for (var zz=0; zz < ranges.length; zz++)
            {
                if (ranges[zz].name == stname)
                {
                    range=ranges[zz];
                    break;
                }
            }
            //Add range
            if (range == null)
            {
                //Create new street and add it to the list
                range={name: stname, min: min, max: max};
                ranges.push(range);
                _suggStreets.push(stname);
            }
            else
            {
                //Update street range
                if (min < range.min)
                {
                    range.min=min;
                }
                if (max > range.max)
                {
                    range.max=max;
                }
            }
        
            //**Get the min max objects**///
            rangesObjArray.push({"name":stname, "min":min, "max":max});
        }
        if(_suggStreets.length == 1){
            //var sortedRanges = rangesObjArray.sortOn("min", Array.NUMERIC);
            var sortedRanges = rangesObjArray.sort(function (obj1, obj2) {
                return obj1.min - obj2.min;
            });
            var finalRanges = [{"name": sortedRanges[0].name, "min": sortedRanges[0].min, "max": sortedRanges[0].max}];
            for (var sr = 1; sr < sortedRanges.length; sr++){
                if(sortedRanges[sr].min - sortedRanges[sr - 1].max > 99){
                    finalRanges.push(sortedRanges[sr])
                }else{
                    finalRanges[(finalRanges.length - 1)]["max"] = sortedRanges[sr].max;
                }
            }
            ranges = finalRanges;
            this.validRangesHeader = "Valid address ranges for " + sortedRanges[0].name + " are:";
            this.oneSuggStreet = true;
        }else{
            this.oneSuggStreet = false;
            this.validRangesHeader = "Valid address ranges are:";
        }
        if(addressRanges.length == 0){
            this.validRangesHeader = "The address you entered could not be found within Marion County.";
        }
        console.log(ranges);
        this.validStreetRanges = ranges;
        this.dialogShow = true;
        this.searchinput.nativeElement.blur();
    }

    suggestionClicked(suggestion){
        this.searchInProgress = true;
        this.pickedAddress = suggestion;
        
        switch(suggestion["SuggestionType"]){
            case "ParcelNumber":
                this.parcelOrNeighbPicked(suggestion);
                break;
            case "Address":
                this.locationService
                    .getAddressLocation(suggestion)
                    .then(addressLocation => 
                        this.addressLocationPicked(addressLocation))
                    .catch(error => this.error = error); // TODO: Display error message
                break;
            case "Streets":
                this.locationService
                    .getAddressLocation(suggestion)
                    .then(addressLocation => 
                        this.addressLocationPicked(addressLocation))
                    .catch(error => this.error = error); // TODO: Display error message
                break;
            case "Intersection":
                this.locationService
                    .getAddressLocation(suggestion)
                    .then(addressLocation => 
                        this.addressLocationPicked(addressLocation))
                    .catch(error => this.error = error); // TODO: Display error message
                break;
            case "Neighborhood":
                this._esriTasksService.queryFeatures(this.appSettings["AddressLocator"]["neighborhoodsMapService"], null, "NAME = '" + suggestion["FullName"] + "'", [], true, null).then(results => {
                    suggestion["Geometry"] = results["features"][0]["geometry"];
                    this.parcelOrNeighbPicked(suggestion);
                })
                break;
        }
    }

    private parcelOrNeighbPicked(suggestion:any){
        this.ignoreTextChange = true;
        this.searchInProgress = false;
        var suggestionToPass:Object = {};
        for(var prop in suggestion){
            if(prop != "Geometry"){
                suggestionToPass[prop] = suggestion[prop];
            }
        }
        var pickedAddressLocation:Object = {addressSuggestion: suggestionToPass, addressLocation: suggestion["Geometry"]};
        //this._eventsService.changeNav(pickedAddressLocation);
        this.addressLocationOutput.next(pickedAddressLocation);
        this.searchinput.nativeElement.value = this.pickedAddress["FullName"];
        this.suggestions = new Array<Object>();
    }

    // private queryFeaturesBasedOnGeometry(){
    //     this._esriTasksService.queryFeatures
    // }
    
    addressLocationPicked(addressLocation){
        this.ignoreTextChange = true;
        this.searchInProgress = false;
        var pickedAddressLocation:Object = {addressSuggestion: this.pickedAddress, addressLocation: addressLocation[0]};
        //this._eventsService.changeNav(pickedAddressLocation);
        this.addressLocationOutput.next(pickedAddressLocation);
        this.searchinput.nativeElement.value = this.pickedAddress["FullName"];
        this.suggestions = new Array<Object>();
    }
    
    tableRowClick(event:any) {
        alert("row click");
    }
}


// WEBPACK FOOTER //
// ./app/tools/addressLocator.component.ts